var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8203 116.641V118.234C39.8203 120.125 39.8203 122.07 39.3047 125.047L37.5391 124.891C38.0859 122.117 38.0859 120.07 38.0859 118.234V118.047H29.9453V116.641H39.8203ZM28.5859 127.453V126.031H41.4609V127.453H28.5859ZM55.3203 126.297V127.719H42.4141V126.297H55.3203ZM43.9141 117.672V116.266H53.7891V120.812H45.6797V122.656H54.1172V124.031H43.9453V119.422H52.0703V117.672H43.9141ZM69.1484 126.297V127.719H56.2422V126.297H69.1484ZM57.7422 117.672V116.266H67.6172V120.812H59.5078V122.656H67.9453V124.031H57.7734V119.422H65.8984V117.672H57.7422ZM81.2109 115.281V118.297H83.1953V119.719H81.2109V122.734H79.4766V115.281H81.2109ZM70.0234 121.469C73.4844 120.75 75.1953 119.203 75.4219 117.328H70.7266V115.922H77.3672C77.3594 119.625 74.9766 121.945 70.6797 122.891L70.0234 121.469ZM71.3984 124.641V123.359H76.1172V126.844H73.1328V127.938C75.0625 127.938 75.9609 127.883 77.0234 127.641L77.1953 128.938C75.9453 129.219 74.9297 129.242 72.3359 129.234H71.4297V125.625H74.4297V124.641H71.3984ZM76.7266 124.703V123.359H81.2109V129.297H79.4922V124.703H76.7266ZM100.602 126.234V127.688H87.6953V126.234H100.602ZM88.7578 117.969V116.578H99.4766V117.969H97.4141V122.469H99.4297V123.844H88.8047V122.469H90.7891V117.969H88.7578ZM92.5234 122.469H95.6953V117.969H92.5234V122.469ZM114.43 126.312V127.75H101.523V126.312H107.086V124.016H103.055V119.391H111.18V117.641H103.023V116.234H112.898V120.766H104.789V122.594H113.227V124.016H108.805V126.312H114.43Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 49.0005C119.019 75.5258 97.5238 97.0205 70.9985 97.0205C44.4732 97.0205 22.9785 75.5258 22.9785 49.0005C22.9785 22.4751 44.4732 0.980469 70.9985 0.980469C97.5238 0.980469 119.019 22.4751 119.019 49.0005Z",
    fill: "url(#paint0_linear_1275_5303)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9999,
    cy: 48.9999,
    r: 42.4906,
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.15 31.8698C93.168 31.9617 93.1839 32.0427 93.2071 32.1007C93.2527 32.2146 92.8855 35.6211 92.4455 39.703C91.817 45.5333 91.0401 52.7415 91.1051 53.7013C91.1051 55.0842 90.2754 70.6277 89.9988 75.5508C89.9435 76.3805 89.2521 77.0443 88.4223 77.0443H88.0628C87.1777 77.0443 86.4863 76.3252 86.4863 75.4678C86.4863 71.5404 86.431 61.4178 85.8502 57.9606C85.3523 55.1118 83.9971 54.4204 82.2824 54.3651L81.425 69.0236C81.3697 69.8533 80.6782 70.5171 79.8485 70.5171C79.0188 70.5171 78.3273 69.881 78.272 69.0513L77.3316 54.697C76.0515 54.7815 75.304 54.8819 74.6101 54.975C73.7149 55.0952 72.9091 55.2034 71.164 55.2501H71.1087C69.2674 55.2008 68.4033 55.0928 67.3954 54.9669C66.7077 54.881 65.9529 54.7867 64.7751 54.697L63.8347 69.0513C63.7794 69.881 63.088 70.5171 62.2582 70.5171C61.4285 70.5171 60.7371 69.8533 60.6818 69.0236L59.8244 54.3651C58.1096 54.448 56.7544 55.1118 56.2565 57.9606C55.6481 61.4178 55.6204 71.5404 55.6204 75.4678C55.6204 76.3529 54.9013 77.0443 54.0439 77.0443H53.6844C52.8547 77.0443 52.1632 76.3805 52.1079 75.5508C52.0344 74.098 51.908 71.7205 51.7663 69.0549C51.4276 62.6873 51.0016 54.6761 51.0016 53.7013C51.0016 52.8364 50.349 46.8983 49.752 41.4664C49.2226 36.6495 48.737 32.2307 48.789 32.1007C48.8122 32.0427 48.8281 31.9617 48.8461 31.8698C48.9141 31.5232 49.0124 31.022 49.6464 31.022H52.1356C52.1356 31.022 53.0483 30.3859 54.763 25.5735C56.4143 20.9126 62.5796 20.9452 64.244 20.954C64.308 20.9544 64.3654 20.9547 64.4155 20.9547H77.7742C77.8245 20.9547 77.8819 20.9544 77.9456 20.954C79.5979 20.9452 85.582 20.9133 87.2331 25.5735C88.9478 30.3859 89.8605 31.022 89.8605 31.022H92.3497C92.9837 31.022 93.082 31.5232 93.15 31.8698ZM62.0646 46.8422L63.2539 27.8967C63.3645 26.4585 62.6454 25.1033 60.7094 25.8501C59.4798 26.3244 58.8303 27.8251 58.1445 29.4098C57.7505 30.3202 57.3445 31.2583 56.8097 32.0454C55.7034 33.7878 55.5374 33.8431 54.7077 33.9814C52.4398 34.0367 52.7717 35.8068 52.7717 35.8068C53.9333 48.0591 58.4691 47.4783 58.4691 47.4783H60.8754C62.0923 47.506 62.0646 46.8422 62.0646 46.8422ZM68.8408 39.9831C69.062 39.9831 69.228 39.8172 69.228 39.5959V29.086C69.228 28.8648 69.062 28.6988 68.8408 28.6988C68.6195 28.6988 68.4535 28.8648 68.4535 29.086V39.5959C68.4535 39.8172 68.6195 39.9831 68.8408 39.9831ZM73.3766 39.9831C73.5979 39.9831 73.7638 39.8172 73.7638 39.5959V29.086C73.7638 28.8648 73.5979 28.6988 73.3766 28.6988C73.1553 28.6988 72.9894 28.8648 72.9894 29.086V39.5959C72.9894 39.8172 73.1553 39.9831 73.3766 39.9831ZM83.5269 47.4783C83.5269 47.4783 88.0905 48.0315 89.2244 35.8068C89.2244 35.8068 89.5563 34.0367 87.2884 33.9814C86.4586 33.8431 86.2927 33.7878 85.1864 32.0454C84.5791 31.1517 84.2757 30.0634 83.9909 29.042C83.5882 27.5978 83.2227 26.2875 82.0888 25.8501C80.1527 25.1033 79.406 26.4862 79.5166 27.8967L80.7059 46.8422C80.7059 46.8422 80.6782 47.506 81.8951 47.4783H83.5269ZM71.0813 47.5059C76.7788 47.5059 77.2766 47.3952 77.2766 47.2569C77.2766 47.1187 76.8064 47.008 71.0813 47.008C65.3839 47.008 64.6924 47.1187 64.6924 47.2569C64.6924 47.3952 65.3839 47.5059 71.0813 47.5059Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5303",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5303",
    x: 48.7852,
    y: 20.9531,
    width: 44.4258,
    height: 57.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5303",
    x1: 37.6785,
    y1: 11.4338,
    x2: 107.749,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverChair);
export default __webpack_public_path__ + "static/media/SilverChair.5b8b89fef4477ae896eef559de6b2bf5.svg";
export { ForwardRef as ReactComponent };